import React from "react";
import ProductCard from "./ProductCard";

export default function ProductCards({ title, products, alignHeader}) {
  const align = alignHeader ? alignHeader : 'center';

  return (
    <section className="hds-container bg-white hds-text-color ">
      <div className="hds-section">
        <h3 className={`text-2xl md:text-4xl font-bold font-heading mt-0 mb-8 pt-3 relative leading-none bold-color text-${align} uppercase`}>
          {title}
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 md:gap-6">
          {products.map((product) => (
            <ProductCard product={product} key={product.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
